// Urun olculeri: tedarikci aciklamasindan (Rexven) okunur ve urun OZELLIGI
// olur. Ornekler:
//   "Ürün Ölçüleri: En: 20 mm - Boy: 22 mm"
//   "Not: 13mm x 22mm boyutlarındadır."
//   "Genişlik 1,5 cm, Yükseklik 2 cm"
// Zincir uzunlugu gibi buyuk olculer (inch, 40+ cm) parca olcusu sayilmaz.

export interface ProductDimensions {
  widthMm?: number;
  heightMm?: number;
  /** Ozellik metni: "20 × 22 mm" */
  label: string;
}

const num = (s: string) => Number(s.replace(",", "."));
const toMm = (v: number, unit: string) => (unit.toLowerCase() === "cm" ? v * 10 : v);
const fmt = (v: number) => (Number.isInteger(v) ? String(v) : v.toFixed(1).replace(/\.0$/, ""));
const plausible = (v: number) => v >= 2 && v <= 120;

/** HTML'den duz metin (etiketler ve bosluklar sadelesir) */
export function descriptionPlainText(html?: string | null): string {
  return String(html ?? "")
    .replace(/<br\s*\/?>/gi, "\n").replace(/<\/(p|div|li|h\d)>/gi, "\n")
    .replace(/<[^>]+>/g, " ").replace(/&nbsp;/g, " ").replace(/&amp;/g, "&")
    .replace(/[ \t]+/g, " ").replace(/\n\s*\n+/g, "\n").trim();
}

export function extractProductDimensions(text?: string | null): ProductDimensions | null {
  const t = descriptionPlainText(text);
  if (!t) return null;
  const UNIT = "(mm|cm)";
  const N = "(\\d+(?:[.,]\\d+)?)";

  // 1) Etiketli: "En: 20 mm - Boy: 22 mm" / "Genislik 15 mm Yukseklik 20 mm"
  const wM = t.match(new RegExp(`(?:\\ben\\b|geni[sş]lik|width|wide)\\s*[:=]?\\s*${N}\\s*${UNIT}`, "i"));
  const hM = t.match(new RegExp(`(?:\\bboy\\b|y[uü]kseklik|height|tall|long)\\s*[:=]?\\s*${N}\\s*${UNIT}`, "i"));
  let w = wM ? toMm(num(wM[1]), wM[2]) : undefined;
  let h = hM ? toMm(num(hM[1]), hM[2]) : undefined;

  // 2) Cift: "13mm x 22mm", "20 x 22 mm", "1,5 x 2 cm"
  if (w == null && h == null) {
    const pair = t.match(new RegExp(`${N}\\s*${UNIT}?\\s*[x×*]\\s*${N}\\s*${UNIT}`, "i"));
    if (pair) {
      const unit = pair[4];
      w = toMm(num(pair[1]), pair[2] || unit);
      h = toMm(num(pair[3]), unit);
    }
  }

  // 3) "Ürün Ölçüleri: 18 mm" gibi tek deger (yalnizca olcu satirinda)
  if (w == null && h == null) {
    const line = t.split("\n").find((l) => /(ölçü|olcu|boyut|dimension|size)/i.test(l) && !/(zincir|chain|inch|inç|")/i.test(l));
    const one = line?.match(new RegExp(`${N}\\s*${UNIT}`, "i"));
    if (one) w = toMm(num(one[1]), one[2]);
  }

  if (w != null && !plausible(w)) w = undefined;
  if (h != null && !plausible(h)) h = undefined;
  if (w == null && h == null) return null;
  const label = w != null && h != null ? `${fmt(w)} × ${fmt(h)} mm` : `${fmt((w ?? h)!)} mm`;
  return { ...(w != null ? { widthMm: w } : {}), ...(h != null ? { heightMm: h } : {}), label };
}

/** Ozelliklerde kullanilan ad */
export const DIMENSIONS_ATTRIBUTE = "Ürün Ölçüleri";
